import { GridStateSnapshot } from 'react-virtuoso';
import {
  RestoreFeedBaseProps,
  useRestoreFeedBase,
} from '@/components/feed/restore-feed/use-restore-feed-base.ts';

const feedPositions: Map<string, GridStateSnapshot> = new Map();

export const hasGridFeedPosition = (key: string | null | undefined) =>
  key ? feedPositions.has(key) : false;
export const removeGridFeedPosition = (key: string) =>
  feedPositions.delete(key);

export const useRestoreGridFeed = ({
  getKey,
  onRestore,
}: RestoreFeedBaseProps = {}) => {
  const { key, style, restoreStateFrom } = useRestoreFeedBase({
    feedPositions,
    onRestore,
    getKey,
  });

  const setFeedPosition = (gss: GridStateSnapshot) => {
    feedPositions.set(key, gss);
  };

  return {
    restoreStateFrom: restoreStateFrom as GridStateSnapshot | undefined,
    setFeedPosition,
    style,
  };
};
